var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "perfect-scrollbar",
    {
      staticClass: "flex-grow-1 d-flex flex-column mt-0",
      attrs: { options: _vm.opsScroll }
    },
    [
      _c(
        "b-card",
        { staticClass: "flex-grow-1", attrs: { "footer-tag": "footer" } },
        [
          _c(
            "b-list-group",
            { staticClass: "mb-4" },
            [
              _c("b-list-group-item", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between" },
                  [
                    _c("span", [_vm._v("Завершено заказов в этом месяце:")]),
                    _vm._v(" "),
                    _vm.monthStatLoading
                      ? _c("b-spinner", {
                          staticClass: "mr-2",
                          attrs: { type: "border", variant: "dark", small: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.monthStatLoading
                      ? _c("span", [_vm._v(_vm._s(_vm.monthOrders))])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-list-group-item", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between" },
                  [
                    _c("span", [_vm._v("Заработано в этом месяце:")]),
                    _vm._v(" "),
                    _vm.monthStatLoading
                      ? _c("b-spinner", {
                          staticClass: "mr-2",
                          attrs: { type: "border", variant: "dark", small: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.monthStatLoading
                      ? _c("span", [_vm._v(_vm._s(_vm.monthSalary) + " руб")])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-list-group",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0 flex-grow-0 ",
                  attrs: { "label-size": "sm" }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "picker-options": _vm.datePickerOptions,
                      "value-format": "yyyy-MM-dd",
                      format: "dd.MM.yyyy",
                      type: "date",
                      placeholder: "Выбрать день",
                      disabledDate: "disabledDate"
                    },
                    model: {
                      value: _vm.actualDate,
                      callback: function($$v) {
                        _vm.actualDate = $$v
                      },
                      expression: "actualDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("h3", { staticClass: "d-flex justify-content-center mt-2" }, [
                _vm._v("Статистика за смену")
              ]),
              _vm._v(" "),
              _c("courier-stat", {
                ref: "courStat",
                attrs: { orders: _vm.orders }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", [_vm._v("Зарплата за смену: ")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.allSum) + " руб")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ae1bc53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae1bc53","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourierStatistic.vue
// module id = null
// module chunks = 